<template>
  <!-- type -->
  <AppTooltip trigger="click" placement="bottom">
    <!-- HANDLER -->
    <template #tooltip-handler>
      <Badge class="card-details__type-item" :icon="icon">
        <span>{{ type === 'recurrent' ? isRecurrent : isTechnical }}</span>
      </Badge>
    </template>
    <!-- CONTENT -->
    <template #tooltip-content>
      <CardModalDetailsTypeText :type-text="cardTypeText" />
    </template>
  </AppTooltip>
</template>

<script>
// Utilities
import { actionTypes } from 'Utils/config/diy'
// Components
import Badge from 'Ui/AppBadge'
import AppTooltip from 'Ui/AppTooltip'
import CardModalDetailsTypeText from './CardModalDetailsTypeText'

export default {
  name: 'CardModalDetailsType',

  components: {
    Badge,
    AppTooltip,
    CardModalDetailsTypeText,
  },

  props: {
    card: {
      type: Object,
      required: true,
    },

    type: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      types: { ...actionTypes },
    }
  },

  computed: {
    userLanguage() {
      return this.$store.state.user.currentUser.language
    },

    cardTypeText() {
      return this.type === 'recurrent'
        ? this.types[this.userLanguage].recurrent
        : this.types[this.userLanguage].technical
    },

    isTechnical() {
      if (this.card.technical) {
        return this.$t('ui.badges.card_type.technical')
      } else {
        return this.$t('ui.badges.card_type.non_technical')
      }
    },

    isRecurrent() {
      if (this.card.recurrent) {
        return this.$t('ui.badges.card_type.recurrent')
      } else {
        return this.$t('ui.badges.card_type.punctual')
      }
    },

    icon() {
      return this.type === 'recurrent' ? 'far fa-repeat' : 'far fa-tools'
    },
  },
}
</script>

<style scoped>
.card-details__type-item {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  font-size: 9px;
  font-weight: 700;
  line-height: 9px;
  letter-spacing: 2px;
  padding: 0 10px;
  border-radius: 4px;
  height: 30px;
  color: var(--c-secondary);
  background-color: var(--c-secondary-400);
  text-transform: uppercase;
  cursor: pointer;
}

.card-details__type-item:hover {
  background-color: var(--c-secondary-500);
}

.card-details__type-item .app-icon {
  font-size: 10px;
  margin-right: 5px;
  color: var(--c-secondary);
}

.card-details__type-item:not(:last-of-type) {
  margin-right: 10px;
}

.card-details__type-item span {
  font-size: 9px;
  color: var(--c-secondary-700);
}
</style>
